const readText = (value: unknown): string => String(value ?? '').trim();

export const normalizeFinancialAidAcademicYearLabel = (value: unknown): string | null => {
  const match = readText(value).match(/^(\d{4})\s*-\s*(\d{4})$/);
  if (!match) return null;
  const startYear = Number(match[1]);
  const endYear = Number(match[2]);
  if (
    !Number.isFinite(startYear)
    || !Number.isFinite(endYear)
    || startYear <= 1900
    || endYear !== startYear + 1
  ) {
    return null;
  }
  return `${startYear}-${endYear}`;
};

export const getFinancialAidAcademicYearStartYear = (value: unknown): number | null => {
  const match = normalizeFinancialAidAcademicYearLabel(value)?.match(/^(\d{4})-\d{4}$/);
  if (!match) return null;
  const year = Number(match[1]);
  return Number.isFinite(year) ? year : null;
};
